<template>
    <AppMainSearchCard :tituloTela="tituloTela" :isLoading="isLoadingPlantasAbate"
        @add="$router.push({ path: '/plantaAbate' })">

        <v-layout wrap row justify-center>
            <v-flex class="item" xs11 md11 lg11 pb-2>
                <v-text-field v-model="search" append-icon="fas fa-search" label="Pesquise por Identificador, Registro no SIF ou Nome Fantasia" 
                single-line hide-details outlined clearable ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3>
            <v-flex class="item" sm12 xs12 md12 lg12>
                <v-data-table :headers="headers" :search="search" @click:row="editItem"
                    no-results-text="Nenhum registro encontrado" :loading="isLoadingPlantasAbate"
                    :must-sort="true" :items="plantasAbate" color="secondary"
                    loading-text="Carregando registros...aguarde">
                </v-data-table>
            </v-flex>
        </v-layout>
    </AppMainSearchCard>
</template>

<script>
import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue'

export default {
    components: {
        AppMainSearchCard,
    },
    data: () => ({
        rowsPerPageItems: [5, 10, 15],
        pagination: {'sortBy': 'idPlantaAbate', 'descending': true, 'rowsPerPage': 5},
        tituloTela: 'Pesquisa de Plantas de Abate',
        registroSelected: '',
        headers: [            
            { text: 'Identificador', value: 'idPlantaAbate' },
            { text: 'Registro no SIF', value: 'nrRegistroSif' },
            { text: 'Nome Fantasia', value: 'nmPlantaAbate' },
        ],
        plantasAbate: [],
        isLoadingPlantasAbate: false,
        isErrorPlantaAbate: false,
        query: {},
        search: '',
    }),
    methods: {
        initViewFromRoute(route) {
            this.query = Object.assign({}, route.query)
            this.searchItem()
        },
        editItem (value) {
            this.$router.push({ name: 'plantaAbate', params: { id : value.idPlantaAbate } })
        },
        searchItem() {
            var search = Object.assign({}, this.query)

            this.isLoadingPlantasAbate = true

            this.$axios.get('planta-abate/', { params: search })
            .then((response) => {
                if (response.data[0].data != null)
                    this.plantasAbate = response.data[0].data
            })
            .catch((error) => {
                this.isErrorPlantaAbate = true
                this.$store.commit("setSnack", { type: "error", msg: error })
            })
            .finally(() => {
                this.isLoadingPlantasAbate = false
            })
        },
        routeUpdate() {
            this.$router.push({ path : 'plantaAbateSearch', query: this.query })
        },
    },
    mounted () {
        this.initViewFromRoute(this.$route)
    },
    watch: {
        options: {
            handler () {
                this.searchItem()
            },
            deep: true
        }
    },
    beforeRouteUpdate(to, from, next){
        this.initViewFromRoute(to)
        next()
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
